module.exports = __webpack_public_path__ + "img/tab-active.a480facf.png";